module.exports = __webpack_public_path__ + "static/media/about-column1.0080df77.png";